import API_BASE_URL from './config';
import React, { useState, useEffect } from 'react';

function KennelRegistry() {
  const [kennels, setKennels] = useState([]);
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(true);
  const [playerFilter, setPlayerFilter] = useState('');

  useEffect(() => {
    const fetchKennels = async () => {
      setLoading(true);
      try {
        const res = await fetch(`${API_BASE_URL}/kennel-registry`);
        if (!res.ok) {
          const text = await res.text();
          throw new Error(`Fetch failed: ${res.status} - ${text}`);
        }
        const data = await res.json();
        console.log('KennelRegistry data:', data);
        setKennels(data || []);
      } catch (error) {
        setMessage('Failed to fetch kennel registry: ' + error.message);
        setKennels([]);
      } finally {
        setLoading(false);
      }
    };

    fetchKennels();
  }, []);

  const uniquePlayers = [...new Set(kennels.map(k => k.playerInfo?.username || 'Unknown'))].sort();
  const filteredKennels = playerFilter
    ? kennels.filter(k => (k.playerInfo?.username || 'Unknown') === playerFilter)
    : kennels;

  if (loading) return <p style={{ textAlign: 'center', color: '#888' }}>Loading kennel registry...</p>;

  return (
    <div style={{ maxWidth: '1200px', margin: '0 auto', textAlign: 'center', padding: '20px' }}>
      <h1 style={{ color: '#1E88E5', marginBottom: '20px' }}>Kennel Registry</h1>
      {message && (
        <div style={{
          backgroundColor: '#BBDEFB',
          padding: '10px',
          marginBottom: '20px',
          borderRadius: '5px',
          color: '#333',
          fontWeight: 'bold'
        }}>
          {message}
        </div>
      )}
      <div style={{ marginBottom: '20px' }}>
        <label style={{ marginRight: '10px', fontWeight: 'bold', color: '#333' }}>Sort by Player:</label>
        <select
          value={playerFilter}
          onChange={(e) => setPlayerFilter(e.target.value)}
          style={{ padding: '5px', borderRadius: '5px', border: '1px solid #ccc' }}
        >
          <option value="">All Players</option>
          {uniquePlayers.map(player => (
            <option key={player} value={player}>{player}</option>
          ))}
        </select>
      </div>
      {filteredKennels.length > 0 ? (
        <div style={{
          backgroundColor: '#f9f9f9',
          padding: '20px',
          borderRadius: '8px',
          boxShadow: '0 2px 5px rgba(0,0,0,0.1)',
          border: '1px solid #BBDEFB'
        }}>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '20px', justifyContent: 'center' }}>
            {filteredKennels.map(kennel => (
              <div
                key={kennel._id}
                style={{
                  textAlign: 'center',
                  width: '300px',
                  padding: '15px',
                  backgroundColor: '#fff',
                  borderRadius: '5px',
                  boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                  transition: 'transform 0.2s'
                }}
                onMouseOver={(e) => e.currentTarget.style.transform = 'scale(1.05)'}
                onMouseOut={(e) => e.currentTarget.style.transform = 'scale(1)'}
              >
                {kennel.artUrl ? (
                  <img
                    src={kennel.artUrl}
                    alt={kennel.kennelName}
                    style={{ width: '300px', height: '300px', objectFit: 'cover', borderRadius: '8px' }}
                  />
                ) : (
                  <div style={{
                    width: '300px',
                    height: '300px',
                    backgroundColor: '#E6F0FA',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    borderRadius: '8px',
                    color: '#888',
                    fontWeight: 'bold'
                  }}>
                    No Image
                  </div>
                )}
                <p style={{ margin: '10px 0 5px', fontSize: '16px', color: '#1E88E5', fontWeight: 'bold' }}>{kennel.kennelName}</p>
                <p style={{ margin: '0', fontStyle: 'italic', color: '#333' }}>
                  Owned by {kennel.playerInfo?.username || 'Unknown'}
                </p>
              </div>
            ))}
          </div>
        </div>
      ) : (
        <p style={{ color: '#888', fontSize: '16px' }}>No approved kennels found.</p>
      )}
    </div>
  );
}

export default KennelRegistry;